module.exports = __webpack_public_path__ + "c5e2d663649932dd0e3c2a598bd2db33.svg";